/* istanbul ignore file */
import React, { lazy } from 'react'

import SiteRoute from '../../components/SiteRoute'

const StatePage = lazy(() => import('./pages/StatePage'))
const YearBornPage = lazy(() => import('./pages/YearBornPage'))
const AustraliaNLIHP = lazy(() => import('./pages/AustraliaNLIHP'))

export default [
  <SiteRoute key="nlihp" exact path="/" component={AustraliaNLIHP} />,
  <SiteRoute key="state" path="/state/:state" component={StatePage} />,
  <SiteRoute key="yearborn" exact path="/year-born/:year" component={YearBornPage} />,
]
